/**
 * Function to detect if an email is fancy (has colored backgrounds, etc.)
 */
export const detectFancyEmail = (htmlContent: string): boolean => {
  if (!htmlContent) return false;

  // Check if the body tag has a background color or image via CSS style
  const bodyWithBackgroundStyle =
    /<body[^>]*style="[^"]*background(?:-color|-image)?:[^"]*"/i.test(
      htmlContent,
    );

  // Check if the body tag has a bgcolor attribute (older HTML)
  const bodyWithBgcolorAttr = /<body[^>]*bgcolor=[^>]*>/i.test(htmlContent);

  return bodyWithBackgroundStyle || bodyWithBgcolorAttr;
};

/**
 * Determine the email type class for styling
 */
export const getEmailTypeClass = (
  isDraft: boolean,
  isSent: boolean,
): string => {
  if (isDraft) return 'draft';
  if (isSent) return 'sent';
  return 'inbox';
};
